module.exports = "https://99designs-start-assets.imgix.net/js/e87dc88482ea5669cba8d18e6a3ad3fd.png";